import { Dialog, DialogTitle } from "@mui/material";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { cargarSolicitudReingreso } from "../../../../../redux/actions/siniestralidad";
import { convertDateTimeToNet } from "../../../../../util/datetime";
import { mapDocumentFilesToMetadata } from "../../../../../util/files";
import ConfirmDialog from "../../../../commons/dialog/ConfirmDialog";
import SolicitudReingresoForm from "./SolicitudReingresoForm";
const initialValues = {
  observaciones: "",
  archivos: [],
  siniestroART: "",
  tipoSiniestro: "",
  nroDocumento: "",
  apellidoNombre: "",
};

const SolicitudReingresoDialog = ({
  open,
  handleClose,
  siniestro,
}) => {
  const dispatch = useDispatch();
  const [values, setValues] = useState();
  const [openHandleCloseDialog, setOpenHandleCloseDialog] = useState(open);
  const [files, setFiles] = useState([]);
  useEffect(() => {
    if (siniestro) {
      setValues({
        ...initialValues,
        ...siniestro,
      });
    }
  }, [siniestro]);

  const handleCloseDialog = () => {
    handleClose();
    setFiles([]);
  }

  const handleSubmit = (formValues) => {
    const body = {
      idSiniestroCabecera: formValues.idSiniestroCabecera,
      fechaHoraEvento: convertDateTimeToNet(new Date()),
      observaciones: formValues.observaciones,
      archivosAsociados: mapDocumentFilesToMetadata(files),
    };
    dispatch(cargarSolicitudReingreso(body)).then(() => {
      handleCloseDialog();
      toast.success("Solicitud de reingreso cargada con éxito");
    });
  }

  const handleCancel = () => {
    setOpenHandleCloseDialog(true);
  };

  return (
    <Dialog open={open} onClose={handleCloseDialog}>
      <DialogTitle>Solicitud de Reingreso</DialogTitle>
      <SolicitudReingresoForm
        initialValues={values}
        handleSubmit={handleSubmit}
        handleCancel={handleCancel}
        files={files}
        setFiles={setFiles}
      />
      <ConfirmDialog
        open={openHandleCloseDialog}
        handleClose={() => setOpenHandleCloseDialog(false)}
        handleConfirm={() => {
          handleCloseDialog();
          setOpenHandleCloseDialog(false);
        }}
        title="¿Está seguro que desea salir?"
        text="Se perderán los datos no guardados."
        warningText="Esta acción no se puede deshacer."
      />
    </Dialog>
  );
};

export default SolicitudReingresoDialog;